import React from 'react';
import {Button, GridRow} from "semantic-ui-react";
import {observer} from "mobx-react-lite";
import storage from "../../Stores/UnloadsSettingsStorage";

function NewUnload() {
    return <GridRow>
        <Button fluid color={'teal'}
                onClick={() => storage.startCreatingUnload()}
                content={'Создать'}
                disabled={storage.hasNew || (storage.loading && !storage.isLoaded)}
        />
    </GridRow>
}

export default observer(NewUnload);
